var map = {
	"./square/ac.svg": 1715,
	"./square/ad.svg": 1716,
	"./square/ae.svg": 1717,
	"./square/af.svg": 1718,
	"./square/ag.svg": 1719,
	"./square/ai.svg": 1720,
	"./square/al.svg": 1721,
	"./square/am.svg": 1722,
	"./square/ao.svg": 1723,
	"./square/aq.svg": 1724,
	"./square/ar.svg": 1725,
	"./square/as.svg": 1726,
	"./square/at.svg": 1727,
	"./square/au.svg": 1728,
	"./square/aw.svg": 1729,
	"./square/ax.svg": 1730,
	"./square/az.svg": 1731,
	"./square/ba.svg": 1732,
	"./square/bb.svg": 1733,
	"./square/bd.svg": 1734,
	"./square/be.svg": 1735,
	"./square/bf.svg": 1736,
	"./square/bg.svg": 1737,
	"./square/bh.svg": 1738,
	"./square/bi.svg": 1739,
	"./square/bj.svg": 1740,
	"./square/bl.svg": 1741,
	"./square/bm.svg": 1742,
	"./square/bn.svg": 1743,
	"./square/bo.svg": 1744,
	"./square/bq.svg": 1745,
	"./square/br.svg": 1746,
	"./square/bs.svg": 1747,
	"./square/bt.svg": 1748,
	"./square/bv.svg": 1749,
	"./square/bw.svg": 1750,
	"./square/by.svg": 1751,
	"./square/bz.svg": 1752,
	"./square/ca.svg": 1753,
	"./square/cc.svg": 1754,
	"./square/cd.svg": 1755,
	"./square/cefta.svg": 1756,
	"./square/cf.svg": 1757,
	"./square/cg.svg": 1758,
	"./square/ch.svg": 1759,
	"./square/ci.svg": 1760,
	"./square/ck.svg": 1761,
	"./square/cl.svg": 1762,
	"./square/cm.svg": 1763,
	"./square/cn.svg": 1764,
	"./square/co.svg": 1765,
	"./square/cp.svg": 1766,
	"./square/cr.svg": 1767,
	"./square/cu.svg": 1768,
	"./square/cv.svg": 1769,
	"./square/cw.svg": 1770,
	"./square/cx.svg": 1771,
	"./square/cy.svg": 1772,
	"./square/cz.svg": 1773,
	"./square/de.svg": 1774,
	"./square/dg.svg": 1775,
	"./square/dj.svg": 1776,
	"./square/dk.svg": 1777,
	"./square/dm.svg": 1778,
	"./square/do.svg": 1779,
	"./square/dz.svg": 1780,
	"./square/ea.svg": 1781,
	"./square/ec.svg": 1782,
	"./square/ee.svg": 1783,
	"./square/eg.svg": 1784,
	"./square/eh.svg": 1785,
	"./square/er.svg": 1786,
	"./square/es-ct.svg": 1787,
	"./square/es-ga.svg": 1788,
	"./square/es.svg": 1789,
	"./square/et.svg": 1790,
	"./square/eu.svg": 1791,
	"./square/fi.svg": 1792,
	"./square/fj.svg": 1793,
	"./square/fk.svg": 1794,
	"./square/fm.svg": 1795,
	"./square/fo.svg": 1796,
	"./square/fr.svg": 1797,
	"./square/ga.svg": 1798,
	"./square/gb-eng.svg": 1799,
	"./square/gb-nir.svg": 1800,
	"./square/gb-sct.svg": 1801,
	"./square/gb-wls.svg": 1802,
	"./square/gb.svg": 1803,
	"./square/gd.svg": 1804,
	"./square/ge.svg": 1805,
	"./square/gf.svg": 1806,
	"./square/gg.svg": 1807,
	"./square/gh.svg": 1808,
	"./square/gi.svg": 1809,
	"./square/gl.svg": 1810,
	"./square/gm.svg": 1811,
	"./square/gn.svg": 1812,
	"./square/gp.svg": 1813,
	"./square/gq.svg": 1814,
	"./square/gr.svg": 1815,
	"./square/gs.svg": 1816,
	"./square/gt.svg": 1817,
	"./square/gu.svg": 1818,
	"./square/gw.svg": 1819,
	"./square/gy.svg": 1820,
	"./square/hk.svg": 1821,
	"./square/hm.svg": 1822,
	"./square/hn.svg": 1823,
	"./square/hr.svg": 1824,
	"./square/ht.svg": 1825,
	"./square/hu.svg": 1826,
	"./square/ic.svg": 1827,
	"./square/id.svg": 1828,
	"./square/ie.svg": 1829,
	"./square/il.svg": 1830,
	"./square/im.svg": 1831,
	"./square/in.svg": 1832,
	"./square/io.svg": 1833,
	"./square/iq.svg": 1834,
	"./square/ir.svg": 1835,
	"./square/is.svg": 1836,
	"./square/it.svg": 1837,
	"./square/je.svg": 1838,
	"./square/jm.svg": 1839,
	"./square/jo.svg": 1840,
	"./square/jp.svg": 1841,
	"./square/ke.svg": 1842,
	"./square/kg.svg": 1843,
	"./square/kh.svg": 1844,
	"./square/ki.svg": 1845,
	"./square/km.svg": 1846,
	"./square/kn.svg": 1847,
	"./square/kp.svg": 1848,
	"./square/kr.svg": 1849,
	"./square/kw.svg": 1850,
	"./square/ky.svg": 1851,
	"./square/kz.svg": 1852,
	"./square/la.svg": 1853,
	"./square/lb.svg": 1854,
	"./square/lc.svg": 1855,
	"./square/li.svg": 1856,
	"./square/lk.svg": 1857,
	"./square/lr.svg": 1858,
	"./square/ls.svg": 1859,
	"./square/lt.svg": 1860,
	"./square/lu.svg": 1861,
	"./square/lv.svg": 1862,
	"./square/ly.svg": 1863,
	"./square/ma.svg": 1864,
	"./square/mc.svg": 1865,
	"./square/md.svg": 1866,
	"./square/me.svg": 1867,
	"./square/mf.svg": 1868,
	"./square/mg.svg": 1869,
	"./square/mh.svg": 1870,
	"./square/mk.svg": 1871,
	"./square/ml.svg": 1872,
	"./square/mm.svg": 1873,
	"./square/mn.svg": 1874,
	"./square/mo.svg": 1875,
	"./square/mp.svg": 1876,
	"./square/mq.svg": 1877,
	"./square/mr.svg": 1878,
	"./square/ms.svg": 1879,
	"./square/mt.svg": 1880,
	"./square/mu.svg": 1881,
	"./square/mv.svg": 1882,
	"./square/mw.svg": 1883,
	"./square/mx.svg": 1884,
	"./square/my.svg": 1885,
	"./square/mz.svg": 1886,
	"./square/na.svg": 1887,
	"./square/nc.svg": 1888,
	"./square/ne.svg": 1889,
	"./square/nf.svg": 1890,
	"./square/ng.svg": 1891,
	"./square/ni.svg": 1892,
	"./square/nl.svg": 1893,
	"./square/no.svg": 1894,
	"./square/np.svg": 1895,
	"./square/nr.svg": 1896,
	"./square/nu.svg": 1897,
	"./square/nz.svg": 1898,
	"./square/om.svg": 1899,
	"./square/pa.svg": 1900,
	"./square/pe.svg": 1901,
	"./square/pf.svg": 1902,
	"./square/pg.svg": 1903,
	"./square/ph.svg": 1904,
	"./square/pk.svg": 1905,
	"./square/pl.svg": 1906,
	"./square/pm.svg": 1907,
	"./square/pn.svg": 1908,
	"./square/pr.svg": 1909,
	"./square/ps.svg": 1910,
	"./square/pt.svg": 1911,
	"./square/pw.svg": 1912,
	"./square/py.svg": 1913,
	"./square/qa.svg": 1914,
	"./square/re.svg": 1915,
	"./square/ro.svg": 1916,
	"./square/rs.svg": 1917,
	"./square/ru.svg": 1918,
	"./square/rw.svg": 1919,
	"./square/sa.svg": 1920,
	"./square/sb.svg": 1921,
	"./square/sc.svg": 1922,
	"./square/sd.svg": 1923,
	"./square/se.svg": 1924,
	"./square/sg.svg": 1925,
	"./square/sh.svg": 1926,
	"./square/si.svg": 1927,
	"./square/sj.svg": 1928,
	"./square/sk.svg": 1929,
	"./square/sl.svg": 1930,
	"./square/sm.svg": 1931,
	"./square/sn.svg": 1932,
	"./square/so.svg": 1933,
	"./square/sr.svg": 1934,
	"./square/ss.svg": 1935,
	"./square/st.svg": 1936,
	"./square/sv.svg": 1937,
	"./square/sx.svg": 1938,
	"./square/sy.svg": 1939,
	"./square/sz.svg": 1940,
	"./square/ta.svg": 1941,
	"./square/tc.svg": 1942,
	"./square/td.svg": 1943,
	"./square/tf.svg": 1944,
	"./square/tg.svg": 1945,
	"./square/th.svg": 1946,
	"./square/tj.svg": 1947,
	"./square/tk.svg": 1948,
	"./square/tl.svg": 1949,
	"./square/tm.svg": 1950,
	"./square/tn.svg": 1951,
	"./square/to.svg": 1952,
	"./square/tr.svg": 1953,
	"./square/tt.svg": 1954,
	"./square/tv.svg": 1955,
	"./square/tw.svg": 1956,
	"./square/tz.svg": 1957,
	"./square/ua.svg": 1958,
	"./square/ug.svg": 1959,
	"./square/um.svg": 1960,
	"./square/un.svg": 1961,
	"./square/us.svg": 1962,
	"./square/uy.svg": 1963,
	"./square/uz.svg": 1964,
	"./square/va.svg": 1965,
	"./square/vc.svg": 1966,
	"./square/ve.svg": 1967,
	"./square/vg.svg": 1968,
	"./square/vi.svg": 1969,
	"./square/vn.svg": 1970,
	"./square/vu.svg": 1971,
	"./square/wf.svg": 1972,
	"./square/ws.svg": 1973,
	"./square/xk.svg": 1974,
	"./square/xx.svg": 1975,
	"./square/ye.svg": 1976,
	"./square/yt.svg": 1977,
	"./square/za.svg": 1978,
	"./square/zm.svg": 1979,
	"./square/zw.svg": 1980
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1714;